@if(isLoggingIn()){
<main class="flex items-center justify-center w-full min-h-screen bg-container-bg-default">
  <mat-spinner diameter="32"></mat-spinner>
</main>
} @else {
<router-outlet></router-outlet>
}
